import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { BannerType, BannerIconConfig } from './simple-banner.constants';

@Component({
  selector: 'app-simple-banner',
  templateUrl: './simple-banner.component.html',
  styleUrls: ['./simple-banner.component.scss'],
})
export class SimpleBannerComponent implements OnInit {
  protected readonly classPrefix = 'simple-banner';

  protected bannerTypeClass!: string;

  protected icon!: string;

  @Input() type: BannerType = BannerType.Info;

  @HostBinding('class') classList = '';

  ngOnInit(): void {
    this.bannerTypeClass = `${this.classPrefix}-${this.type}`;
    this.icon = BannerIconConfig[this.type];
  }
}
